const locale = {
  placeholder: 'Vælg tid',
};

export default locale;
